export * from 'react-content-loader';
export { default as ContentLoader } from 'react-content-loader';

const Circle = 'circle';
const Rect = 'rect';
const Path = 'path';

export { Circle, Rect, Path };
